import { groq } from "next-sanity"

import { groqQueryOptions } from "@/graphql/schemas/shared/utils/groqQueryOptions"
import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { articleMainGroupProjection } from "../sanity/articleMainGroup.projection"

export const queryArticleMainGroups = {
  async articleMainGroups(parent, args, context, info) {
    let { offset, limit, sort, lang = AppSettings.defaultLocale(), cdn = true, sortWithinLimits } = args

    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.AHG,
      operation: Operations.READ,
    })

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const { pipesAndLimits, draftsFilter } = groqQueryOptions({
      sort,
      offset,
      limit,
      sortWithinLimits,
      includeDrafts: true,
    })

    let articleMainGroups
    articleMainGroups = await client.fetch(
      groq`{
        "total": count(*[_type=="articleMainGroup"]),
        "items": *[_type=="articleMainGroup"  ${draftsFilter}]${pipesAndLimits} {
            ...,
           ${articleMainGroupProjection()}
        } 
      }`,
    )

    if (!articleMainGroups)
      articleMainGroups = {
        offset,
        limit,
        count: 0,
        total: 0,
        items: [],
      }

    articleMainGroups = {
      ...articleMainGroups,
      offset,
      limit,
      count: articleMainGroups.items.length,
    }

    return articleMainGroups
  },
}
